"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedflamesm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedflamesm` : '') + (description ? ` desc-brandedflamesm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedflamesm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedflamesm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 12.5C16 15.2746 14.2291 20 8 20C1.89543 20 0 15.5058 0 12.5C0 6.61727 4.32582 5.541 6.37992 0.3174C6.44133 0.161234 6.63966 0.104773 6.77237 0.207472C12.4386 4.59233 10.4923 7.52317 10 9C11.2261 9.40869 12.7862 6.14283 13.3151 4.93633C13.3959 4.75198 13.647 4.72846 13.751 4.90081C14.4616 6.07857 16.4105 9.62634 16 12.5Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.75689 15.7668C3.32245 17.3543 4.48045 20.0001 8.42897 20.0001C12.2985 20.0001 13.5 17.3841 13.5 15.6345C13.5 12.2844 8.42289 11.1254 6.89018 8.21067C6.78911 8.01847 6.53184 7.93613 6.34224 8.05613C2.19177 10.6828 2.2073 14.2242 2.75689 15.7668Z",
    fill: "#F7B941"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.50809 16.8696C4.89949 18.0435 5.70088 20 8.43346 20C11.1114 20 11.9429 18.0655 11.9429 16.7717C11.9429 14.2943 8.42925 13.4373 7.36854 11.2819C7.29859 11.1397 7.12055 11.0788 6.98933 11.1676C4.117 13.11 4.12774 15.7288 4.50809 16.8696Z",
    fill: "#FFDC9C"
  }));
};
var _default = exports.default = brandedflamesm;